// src/i18n/locales/en/vip.ts
// All user-facing VIP/upgrade strings — English

const vip = {
  // -------------------------------------------------------------------------
  // Sidebar (DashboardLayout)
  // -------------------------------------------------------------------------
  sidebar: {
    chatLocked: 'NutriBot (VIP)',
    chatLockedHint: 'Upgrade to unlock AI coaching',
  },

  // -------------------------------------------------------------------------
  // ChatBot upgrade elements (ChatBot.tsx)
  // -------------------------------------------------------------------------
  chatBot: {
    lockedStatus: 'VIP only',
    upgradeTitle: 'Unlock NutriBot Coaching',
    upgradeDescription:
      'Get 24/7 access to your personal AI nutrition coach — personalized plans, real-time adjustments, and expert guidance.',
    bullet1: 'Unlimited plan modifications at any time',
    bullet2: 'Real-time meal adjustments & swaps',
    bullet3: 'Proactive coaching & motivational support',
    upgradeCta: 'Upgrade to VIP',
    inputPlaceholder: 'NutriBot is available for VIP members only',
  },

  // -------------------------------------------------------------------------
  // Upgrade modal (UpgradeModal.tsx)
  // -------------------------------------------------------------------------
  upgradeModal: {
    priceFrom: 'Starting from',
    perMonth: ' / month',
    cta: 'Upgrade to VIP',

    shoppingList: {
      title: 'Shopping List is VIP Only',
      description:
        'Your smart, auto-generated shopping list is a VIP feature. Upgrade to get a fully synced, ingredient-level list from your meal plan.',
      bullet1: 'Auto-generated from your active meal plan',
      bullet2: 'Organised by category with quantities',
      bullet3: 'PDF export & smart mode for Swiss retailers',
    },

    recipes: {
      title: 'Detailed Recipes are VIP Only',
      description:
        'VIP members unlock chef-level, step-by-step recipes tied directly to their personalised 30-day plan.',
      bullet1: 'Full ingredient lists with exact measurements',
      bullet2: 'Step-by-step chef-level instructions',
      bullet3: 'Filtered by your allergies and preferences',
    },

    pdfExport: {
      title: 'PDF Export is VIP Only',
      description:
        'Download your full 30-day nutrition plan, recipes, and shopping list as a beautifully formatted PDF.',
      bullet1: 'Complete 30-day plan in one document',
      bullet2: 'Includes recipes and shopping list',
      bullet3: 'Allergy notices and daily calorie overview',
    },

    modifyPlan: {
      title: 'Plan Modifications are VIP Only',
      description:
        'VIP members can adjust, swap, or regenerate any meal or day in their plan at any time through NutriBot.',
      bullet1: 'Swap individual meals or entire days',
      bullet2: 'Adjust calories, macros, and diet type',
      bullet3: 'Unlimited plan versions, updated instantly',
    },
  },
};

export default vip;